import axios from "axios";
import { toast } from "react-toastify";
export const GetAllbanks = (data) => {
  return {
    type: "get_allbanks",
    payload: data,
    loader: false,
  };
};
export function getallbanks() {
  let pgurl = `${
    process.env.REACT_APP_API_URL
  }Accounts/GetBankAccounts?projectid=${localStorage.getItem("ProjectId")}`;
  if (localStorage.getItem("ProjectId") === null) {
    pgurl = `${process.env.REACT_APP_API_URL}Accounts/GetBankAccounts`;
  }
  return (dispatch) => {
    axios({
      url: pgurl,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllbanks(result.data.Data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
export const GetAllCash = (data) => {
  return {
    type: "get_allcash",
    payload: data,
    loader: false,
  };
};
export function getallcash() {
  let pgurl = `${
    process.env.REACT_APP_API_URL
  }Accounts/GetCashAccounts?projectid=${localStorage.getItem("ProjectId")}`;
  if (localStorage.getItem("ProjectId") === null) {
    pgurl = `${process.env.REACT_APP_API_URL}Accounts/GetBankAccounts`;
  }
  return (dispatch) => {
    axios({
      url: pgurl,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllCash(result.data.Data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
